export default {
  rowNumber: "الصف",
  to: "إلى",
  from: "من",
  symbol: "الرمز",
  transactionId: "رقم المعاملة",
  amount: "المبلغ المستلم",
  BCEQ: "القيمة عند الاستلام",
  totalBCEQ: "القيمة الإجمالية عند الاستلام",
  date: "وقت التسجيل",
  payDate: "وقت الدفع",
  registerDate: "تاريخ التسجيل",
  description: "للـ",
  giftListIsEmpty: "لا توجد هدايا",
  invited: "مدعو",
  totalReward: "القيمة الإجمالية للمكافأة عند الاستلام",
  totalTooltip1:
    "هذا المبلغ يشير إلى القيمة الإجمالية بالدولار للعملات المشفرة",
  totalTooltip2: "عند الاستلام",
  totalTooltip3: "و",
  totalTooltip4: "القيمة الحالية",
  totalTooltip5: "للمكافآت يمكن رؤيتها في محفظتك.",
  giftsAndRemains: "الحساب المتبقي ومكافآت المهرجان",
  recieveReward:
    "بحفظ العملات المشفرة في محفظة Excoino والمشاركة في المهرجانات المختلفة، يمكنك الحصول على مكافآت.",
  guidAndRules: "إرشادات وقواعد المكافآت",
  todayGuidValue: "قيمة مكافأة اليوم",
  rewardList: "قائمة المكافآت",
  endOfCampain: "نهاية الحملة"
};
